import React from "react";
import { TableCell, TableRow } from "../../design/table";
import { FinancialItem } from "../../models/FinancialItem";
import moment from "moment";
import { Link } from "../../design/link";
import OwnershipStatusBadge from "../../components/OwnershipStatusBadge";
import { EllipsisHorizontalIcon } from "@heroicons/react/20/solid";
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownMenu,
} from "../../design/dropdown";
import { useFinancialItem } from "../../contexts/FinancialItemContext";
import { Subheading } from "../../design/heading";
import { Text } from "../../design/text";
import { Tooltip } from "../../design/tooltip";
import { Badge } from "../../design/badge";

interface Props {
  financialItem: FinancialItem;
}

const FinancialItemListItem: React.FC<Props> = ({ financialItem }) => {
  const { deleteFinancialItemById } = useFinancialItem();
  const netEquity =
    (financialItem.amount ?? 0) - (financialItem.associatedDebtAmount ?? 0);

  const handleDelete = async () => {
    await deleteFinancialItemById(financialItem._id);
  };

  return (
    <TableRow>
      <TableCell className="w-1/6">
        <Link href={`/financial-item/${financialItem._id}`}>
          <Subheading>{financialItem.name}</Subheading>
        </Link>
      </TableCell>

      <TableCell className="w-1/12">
        <OwnershipStatusBadge ownershipStatus={financialItem.ownershipStatus} />
      </TableCell>

      <TableCell className="w-1/6">
        {financialItem.amount !== undefined
          ? financialItem.amount.toLocaleString("en-US", {
              style: "currency",
              currency: financialItem.currency,
            })
          : "--"}
      </TableCell>

      <TableCell className="w-1/6">
        {financialItem.associatedDebtAmount !== undefined
          ? financialItem.associatedDebtAmount.toLocaleString("en-US", {
              style: "currency",
              currency: financialItem.currency,
            })
          : "--"}
      </TableCell>

      <TableCell className="w-1/6">
        {netEquity.toLocaleString("en-US", {
          style: "currency",
          currency: financialItem.currency,
        })}
      </TableCell>

      <TableCell className="w-1/6">
        {financialItem.financialAccount ? (
          <div className="flex items-center gap-2">
            <Tooltip
              content={`Synced ${moment(financialItem.dateValued).fromNow()}`}
            >
              <Badge color="blue">Synced</Badge>
            </Tooltip>
          </div>
        ) : null}
      </TableCell>

      <TableCell className="w-1/12 text-center">
        <Dropdown>
          <DropdownButton plain>
            <EllipsisHorizontalIcon className="w-4 h-4" />
          </DropdownButton>
          <DropdownMenu>
            <DropdownItem href={`/financial-item/${financialItem._id}`}>
              Edit
            </DropdownItem>
            <DropdownItem onClick={handleDelete}>Delete</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </TableCell>
    </TableRow>
  );
};

export default FinancialItemListItem;
